import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
import { LMS_APP, isSessionJwt } from './session.utils';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = localStorage.getItem('token');
  const isRefreshOrLogout =
    req.url.includes('/public/refresh') || req.url.includes('/public/logout');

  const headers: Record<string, string> = { 'X-App': LMS_APP };
  if (token && !isRefreshOrLogout) {
    headers['token'] = token;
  }

  const cloned = req.clone({
    withCredentials: true,
    setHeaders: headers
  });

  return next(cloned).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        (error.status !== 499 && error.status !== 401) ||
        isRefreshOrLogout ||
        !isSessionJwt(localStorage.getItem('token')) ||
        (req.url.startsWith(`${environment.apiUrl}public/`) &&
          !req.url.includes('/public/me'))
      ) {
        return throwError(() => error);
      }
      return from(auth.refreshSession()).pipe(
        switchMap((ok) => {
          if (!ok) {
            return throwError(() => error);
          }
          const retriedToken = localStorage.getItem('token') ?? '';
          return next(
            cloned.clone({
              withCredentials: true,
              setHeaders: { 'X-App': LMS_APP, token: retriedToken }
            })
          );
        })
      );
    })
  );
};
